<template>
    <div class="PartnerWelcome">
        <v-row>
            <v-col>
                <h1 class="text-center">
                    BEJELENTKEZÉS
                </h1>
            </v-col>
        </v-row>
        <v-row v-if="showForm">
            <v-col>
                <ValidationObserver v-slot="{ invalid, pristine }" slim ref="observer">
                    <v-form @keypress.enter.prevent="submit" @submit.prevent="submit">
                        <v-row>
                            <v-col>
                                <ValidationProvider ref="emailfield" mode="lazy" v-slot="{ errors }" name="E-mail cím" rules="required|max:255|email">
                                    <v-text-field type="email" @keypress.enter.stop.prevent="submit" v-model="login.email" label="Email cím"
                                                  autocomplete="email" :disabled="loading" :error-messages="errors" autofocus/>
                                </ValidationProvider>

                                <ValidationProvider v-slot="{ errors }" name="Jelszó" rules="required">
                                    <v-text-field @keypress.enter.stop.prevent="submit" v-model="login.password" label="Jelszó" type="password"
                                                  autocomplete="current-password" :disabled="loading" :error-messages="errors"/>
                                </ValidationProvider>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="8">
                                <v-row no-gutters dense>
                                    <v-col cols="12" md="6">
                                        <v-btn small :to="prevRoute || '/'" text dark color="black" tabindex="-1" :disabled="loading">Vissza</v-btn>
                                    </v-col>
                                    <v-spacer/>
                                    <v-col cols="12" md="6">
                                        <a href="/user/password/forgot">
                                            <v-btn small>
                                                Elfelejtett jelszó
                                            </v-btn>
                                        </a>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-btn submit color="primary" @click="submit" :disabled="loading || invalid">
                                    Bejelentkezés
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </ValidationObserver>
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col>
                <p class="text-center">
                A jelentkezés és a belépés az oldalra 2025.szeptember 02-t követően lesz elérhető.
                </p>
            </v-col>
        </v-row>

        <v-row v-if="showForm">
            <v-col md="6" cols="12">
                <v-btn color="primary" to="/regisztracio" :disabled="loading">
                    Látogató vagy? Regisztrálj itt!
                </v-btn>
            </v-col>
            <v-col md="6" cols="12" class="text-right">
                <v-btn color="default" href="/partner/#/reg" :disabled="loading">
                    Intézményként regisztrálj itt!
                </v-btn>
            </v-col>
        </v-row>

        <v-overlay absolute :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="success" color="success">
            {{successText}}
        </v-snackbar>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                login: {
                    email: null,
                    password: null,
                },
                error: false,
                errorItem: {},
                loading: false,
                success: false,
                successText: false,
                prevRoute: null,
                showForm: true
            };
        },
        // on load check the current date
        created() {
            // const currentDate = new Date();
            // const eventDate = new Date('2025-09-03');
            // if (currentDate > eventDate) {
            //     this.showForm = true;
            // }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (!isValid) {
                    return false;
                }

                this.loading = true;
                axios.post('/user/login', this.login)
                .then(data => {
                    if (data.status !== 200 && data.status !== 204 && data || data instanceof Error) {
                        this.error = data.data;
                    } else {
                        this.success = true;
                        this.successText = "Sikeres belépés";
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)
                    }
                }).catch(data => {
                    this.error = true;
                    Object.assign(this.errorItem, data.error);
                })
                .finally(() => {
                    this.loading = false;
                })
            },
            lostpw() {

                this.loading = true;
                axios.post('/user/password/email', this.login)
                .then(data => {
                    if (data.status !== 200 && data.status !== 204 && data || data instanceof Error) {
                        this.error = data.data;
                    } else {
                        this.success = true;
                        this.successText = data.data.message || "Amennyiben az email cím helyes, úgy küldtünk egy emailt, amivel a jelszó helyreállítható.";
                    }
                }).catch(data => {
                    this.error = true;
                    Object.assign(this.errorItem, data.error);
                })
                .finally(() => {
                    this.loading = false;
                })
            }
        },

        beforeRouteEnter(to, from, next) {
            if (window.user) {
                if (window.user.isVisitor) {
                window.location = '/esemenyek'
            } else {
                window.location = '/partner';
            }
                //window.location = '/esemenyek'
                // next('/esemenyek')
            } else {
                next(vm => {
                    vm.prevRoute = from
                });
            }
        }

    };
</script>
